import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'

import Indent from 'components/reusable/indent'
import Button from 'components/reusable/button'
import ModalCloseButton from 'components/modals/v2/modal_close_button'
import { H4 } from 'components/views/help/help_faq_v2/components/styled'
import ModalStandardWrapper from 'components/modals/v2/modal_standard_wrapper'
import StripeHelpers from 'helpers/stripe_helpers'
import PaymentMethodsList from 'components/modals/v2/payment/retry_payment_modal/payment_methods_list'
import { modalEnum } from 'components/modals/v2/modal'
import { useModalContext } from 'hooks/use_context'
import useGetPMDisabled from 'hooks/use_get_pm_disabled'
import useGetUserPaymentCapabilities from 'hooks/api/useGetUserPaymentCapabilities'

const ScrollableListContainer = styled.div`
  position: relative;
  max-height: 400px;
  padding-right: 24px;
  overflow-y: auto;
`

const CardSelectionModal = ({ modalProps = {}, onClose }) => {
  const { onOpenModal } = useModalContext()
  const { onSelectCard, bookeeSwipecastUserId } = modalProps
  const [paymentMethods, setPaymentMethods] = useState([])
  const [selectedPM, setPM] = useState()
  const getPaymentMethodDisabled = useGetPMDisabled()
  const getUserPaymentCapabilities = useGetUserPaymentCapabilities()

  const handleInitPaymentMethods = useCallback(async () => {
    try {
      const pmList = await StripeHelpers.getStripePaymentMethods()
      setPaymentMethods(pmList)
    } catch (error) {
      if (error.status === 404) return
      console.error('Error fetching payment methods:', error)
    }
  }, [])

  useEffect(() => {
    handleInitPaymentMethods()
  }, [])

  useEffect(() => {
    if (bookeeSwipecastUserId) getUserPaymentCapabilities(bookeeSwipecastUserId)
  }, [bookeeSwipecastUserId])

  const handleSubmit = useCallback(() => {
    if (!selectedPM) return
    if (selectedPM === 'new-card') return onOpenModal(modalEnum.addCard, { onAddCard: onSelectCard })

    // Prevent submitting disabled payment methods
    if (getPaymentMethodDisabled(selectedPM)) return

    onSelectCard(selectedPM.stripe_payment_method_id)
  }, [selectedPM, onSelectCard, onOpenModal, getPaymentMethodDisabled])

  return (
    <ModalStandardWrapper $minWidth="480px">
      <ModalCloseButton onClose={onClose} />
      <H4>Select a Card</H4>
      <ScrollableListContainer id="ScrollableListContainer">
        <PaymentMethodsList
          newCard
          onSelect={setPM}
          selectedPM={selectedPM}
          paymentMethods={paymentMethods}
          getPaymentMethodDisabled={getPaymentMethodDisabled}
        />
      </ScrollableListContainer>
      <Indent bottom={24} />
      <Button
        disabled={!selectedPM || (selectedPM !== 'new-card' && getPaymentMethodDisabled(selectedPM))}
        type="primary"
        height={40}
        width="100%"
        onClick={handleSubmit}
      >
        Select
      </Button>
    </ModalStandardWrapper>
  )
}

export default CardSelectionModal
